import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '../shared/shared.module';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {ComponentsModule} from '../components/components.module';
import {PagesRoutingModule} from './pages-routing.module';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatIconModule} from '@angular/material/icon';
import {PlatformRootComponent} from './platform-root/platform-root.component';
import {EventPageComponent} from './website-pages/event-page/event-page.component';

import {StartPageComponent} from './website-pages/start-page/start-page.component';
import {AboutPageComponent} from './website-pages/about-page/about-page.component';
import {ImprintPageComponent} from './website-pages/imprint-page/imprint-page.component';
import {DataProtectionPageComponent} from './website-pages/data-protection-page/data-protection-page.component';
import {ContactPageComponent} from './website-pages/contact-page/contact-page.component';
import {DownloadPageComponent} from './website-pages/download-page/download-page.component';
import {TutorialPageComponent} from './website-pages/tutorial-page/tutorial-page.component';

import {ProposalOverviewComponent} from './proposal-overview/proposal-overview.component';
import {AccountComponent} from './account/account.component';
import {HelpComponent} from './help/help.component';
import {CreateProposalComponent} from './create-proposal/create-proposal.component';
import {ProposalDetailsComponent} from './proposal-detail/proposal-details.component';
import {ProfileUserComponent} from './profile-user/profile-user.component';
import {OnboardingUserComponent} from './onboarding-user/onboarding-user.component';
import {OnboardingCompanyComponent} from './onboarding-company/onboarding-company.component';
import {ProfileCompanyComponent} from './profile-company/profile-company.component';
import {CreateOfferComponent} from './create-offer/create-offer.component';
import {CreateExternalCoverageComponent} from './create-external-coverage/create-external-coverage.component';
import { BillBoardComponent } from './bill-board/bill-board.component';
import { MemberOverviewComponent} from './member-overview/member-overview.component';
import {MarkdownModule} from 'ngx-markdown';
import {NgScrollbarModule} from 'ngx-scrollbar';
import {MatButtonModule} from '@angular/material/button';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatChipsModule} from '@angular/material/chips';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatSelectModule} from '@angular/material/select';
import {MatRadioModule} from '@angular/material/radio';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatInputModule} from '@angular/material/input';
import {MatCardModule} from '@angular/material/card';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatTableModule} from '@angular/material/table';
import {MatMenuModule} from '@angular/material/menu';
import {ProposalPreviewPageComponent} from './proposal-preview-page/proposal-preview-page.component';
import {MatGridList, MatGridTile, MatGridTileHeaderCssMatStyler, MatGridTileText} from '@angular/material/grid-list';
import {MailingsComponent} from './mailings/mailings.component';
import {OfferPreviewPageComponent} from './offer-preview-page/offer-preview-page.component';
import {ErrorRoleComponent} from './error-role/error-role.component';


@NgModule({ exports: [
        ProposalPreviewPageComponent
    ],
    declarations: [
        StartPageComponent,
        ProposalOverviewComponent,
        AccountComponent,
        CreateProposalComponent,
        ProposalDetailsComponent,
        ProfileUserComponent,
        PlatformRootComponent,
        OnboardingUserComponent,
        AboutPageComponent,
        HelpComponent,
        OnboardingCompanyComponent,
        ProfileCompanyComponent,
        ImprintPageComponent,
        EventPageComponent,
        DataProtectionPageComponent,
        ContactPageComponent,
        DownloadPageComponent,
        TutorialPageComponent,
        CreateOfferComponent,
        CreateExternalCoverageComponent,
        ProposalPreviewPageComponent,
        BillBoardComponent,
        MemberOverviewComponent,
        MailingsComponent,
        OfferPreviewPageComponent,
        ErrorRoleComponent
    ], imports: [CommonModule,
        SharedModule,
        ComponentsModule,
        MatButtonModule,
        PagesRoutingModule,
        MatProgressSpinnerModule,
        NgScrollbarModule,
        MatExpansionModule,
        MatIconModule,
        MatChipsModule,
        MatSlideToggleModule,
        MatSelectModule,
        MatRadioModule,
        MatCheckboxModule,
        MatInputModule,
        MatCardModule,
        MatTooltipModule,
        MatSnackBarModule,
        MatTableModule,
        MatMenuModule,
        MarkdownModule,
        MatGridList,
        MatGridTile,
        MatGridTileHeaderCssMatStyler,
        MatGridTileText], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class PagesModule {
}
